/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 데스크탑의 메인 렌더링 컴포넌트입니다.
 * 이 컴포넌트에서 데스크탑에서 렌더되는 모든 항목의 렌더링을 제어할 수 있습니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import { Switch, Route, HashRouter, useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import Footer from 'common-modules/general/Common/Components/Footer/Desktop';
import Header from 'common-modules/general/Common/Components/Header/Desktop';
import CompanyInfo from './Sales/Company';
import SalesHeader from './Sales/SalesHeader';
import TopBannerComponent from 'common-modules/general/Common/Components/TopBannerContainer';
import Main from 'pages/desktop/Sales/Contents/GeneralOutline/index';
import Info from 'pages/desktop/Sales/Contents/Info/index';
import Location from 'pages/desktop/Sales/Contents/Location/index';
import Exhbt from 'pages/desktop/Sales/Contents/Exhbt/index';
import News from 'pages/desktop/Sales/Contents/News/index';
import NewsDetail from 'pages/desktop/Sales/Contents/News/NewsDetail';
import Household from 'pages/desktop/Sales/Contents/Household/index';
import Event from 'pages/desktop/Sales/Contents/Event/index';
import EventDetailPage from 'pages/desktop/Sales/Contents/Event/OpenPage';
import Street from 'pages/desktop/Sales/Contents/Street/index';
import { RoutesString } from 'common-modules/general/Config/routesString';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import NoticeBurgerMenu from 'common-modules/general/Common/Components/BurgerMenu/NoticeBurgerMenu';
import { useEffect, useState } from 'react';


interface Props {
  mainModel: MainModel;
}

const Desktop = observer(({ mainModel }: Props) => {
  const [isRender, setIsRender] = useState(false);
  const history = useHistory();

  const isHistoryCheck = () => {
    if (history.location.hash.includes('/comp')) {
      setIsRender(false);
    } else {
      setIsRender(true);
    }
  };

  useEffect(() => {
    const unlisten = history.listen((location, action) => {
      console.log('on route change');
    });

    unlisten();
    isHistoryCheck();
  }, [history, history.location, history.location.hash]);

  return (
    <div>
      {/* 탑배너 데이터가 있을 경우 탑배너를 표출합니다. */}
      {isRender && <TopBannerComponent mainModel={mainModel} isMobile={false} />}

      {/* 브랜드, 분양, 마이홈, 로그인 등이 있는 기본 헤더입니다. */}
      {isRender && mainModel.mainData.loadStatus !== 'PENDING' && <Header />}

      {/* 우측 자료들이 표시되는 메뉴입니다. */}

      {isRender && <NoticeBurgerMenu direction="right" mainModel={mainModel} />}
      {/* 큰 백그라운드 이미지와 관심고객 등록 SNS공유 기능이 있는 헤더입니다. */}

      {isRender && <SalesHeader mainModel={mainModel} />}
      <HashRouter>
        {/* 아래는 소메뉴들의 페이지들입니다. */}
        <Switch>
          <Route path={RoutesString.Main} exact render={props => <Main mainModel={mainModel} />} />
          <Route path={RoutesString.SalesOverView} exact render={props => <Main mainModel={mainModel} />} />
          <Route path={RoutesString.SalesInfo} exact render={props => <Info mainModel={mainModel} />} />
          <Route path={RoutesString.SalesExhbt} exact render={props => <Exhbt />} />
          <Route path={RoutesString.SalesHousehold} render={props => <Household />} />
          <Route path={RoutesString.SalesLocation} exact render={props => <Location />} />
          <Route path={RoutesString.SalesStreet} exact render={props => <Street />} />
          <Route path={RoutesString.SalesNews} exact render={props => <News />} />
          <Route path={RoutesString.SalesNewsDetail} render={props => <NewsDetail />} />
          <Route path={RoutesString.SalesEvent} exact render={props => <Event />} />
          <Route path={RoutesString.SalesEventDetail} render={props => <EventDetailPage />} />
        </Switch>
      </HashRouter>

      {/* 시행사 정보입니다. */}
      {isRender && <CompanyInfo />}

      {/* Footer 입니다. */}
      {isRender && <Footer />}
    </div>
  );
});

export default Desktop;
